export const darkAccent = '#4c4b4b';
// export const primaryColor = '#0062e5';
export const primaryColor = '#00467f'
export const lightAccent = '#cbcbca';
export const tableBorder = '#D9DDE3';
export const tableHeaderBackground = '#F3F3F4';
export const contentBackground = '#f3f3f4';
export const normalText = '#061720';
export const highlightBackground = '#ff0000';
export const highlightText = '#ff0000';
export const menuBackground = '#061720';
export const menuBorder = '#E6E8E9';
export const mediumText = '#80CFF9';

export const lightGrey = '#E6E8E9';
export const darkGrey = '#828B8F';
export const lightBlue = '#ff0000';
export const textBlue = '#061720';
export const red = '#DA001A';
export const redLight = '#FBE5E8';
export const green = '#00A944';
export const greenLight = '#E5F6EC';
export const orange = '#F67600';
export const orangeLight = '#FEF1E5';

export const button = primaryColor;
export const lightButton = lightBlue;


export const dashboardGreen = '#00ba79';
export const dashboardAltGreen = '#00BA1C';
export const dashboardAqua = '#009EBA';
export const dashboardRed = '#ba1c00';
export const dashboardGray = '#686868';
export const dashboardYellow = '#e6a91a';
export const dashboardOrange = '#e67c1a';

export const dashboardLine2 = '#0041BA';
export const dashboardLine3 = '#1c00BA';
export const dashboardLine4 = '#00BA79';
export const dashboardLine5 = '#00BA1C';